import apiClient from "../../utils/apiclient";

export const getTasks=async(token:string)=>{
   return await apiClient.get('/admin/task',{
      headers:{
         Authorization: `Bearer ${token}`
      }
   })
}

export const getdropdowncities=async()=>{
   return await apiClient.get('city/distinctcity',{
     
   })
}

export const viewretailers=async(token:string)=>{
    return await apiClient.get('/admin/task/view-retailers',{
       headers:{
          Authorization: `Bearer ${token}`
       }
    })
 }
export const viewretailersByid=async(token:string,task_id:any)=>{
    return await apiClient.get(`/admin/task/get-task-assigned-detials/${task_id}`,{
       headers:{
          Authorization: `Bearer ${token}`
       }
    })
 }


 export const getcitiesfiter = async (token: number, taskId: string, city_name: string) => {
 
   return apiClient.post(
     '/admin/task/gettaskRetailresByIdwithcityfilter',
     {
       task_id: taskId,
       city_name: city_name,
     },
     {
       headers: {
         Authorization: `Bearer ${token}`,
       },
     }
   );
 };
 


 export const assignTask = async (token: string, taskId: string, userIds: number[]) => {
 
   return apiClient.post(
     '/admin/task/assign-task_v1',
     {
       task_id: taskId,
       user_ids: userIds,
     },
     {
       headers: {
         Authorization: `Bearer ${token}`,
       },
     }
   );
 };

  export const assignTasktest = async (token: string, taskId: string, userIds: number[],end_date: string,
  end_time: string | null,) => {
 
   return apiClient.post(
     '/admin/task/assign-task_v1',
     {
       task_id: taskId,
       user_ids: userIds,
        end_date,
      end_time,
     },
     {
       headers: {
         Authorization: `Bearer ${token}`,
       },
     }
   );
 };
 
 export const AssignTaskcohorts = async (token: string, taskId: string, cohort_ids: number[]) => {
 
  return apiClient.post(
    '/admin/task/assign_Tasks_cohorts_v1',
    {
      task_id: taskId,
      cohort_ids: cohort_ids,
    },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
};


 export const scheduleAssign = async (token: string, task_id: string, user_ids: number[], start_date: string,
  start_time: string | null,
  end_date: string,
  end_time: string | null,) => {
 
  return apiClient.post(
    '/admin/task/schedule_Assign_task_v1',
    {
      task_id: task_id,
      user_ids: user_ids,
      start_date,
      start_time,
      end_date,
      end_time,
      // date:date,
      // time:time
    },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
};



export const scheduleAssignfinal = async (token: string, task_id: string, user_ids: number[], start_date: string,
  start_time: string | null,
  end_date: string,
  end_time: string | null,cohort_ids:number) => {
 
  return apiClient.post(
    '/admin/task/cohort_schedule_final',
    {
      task_id: task_id,
      user_ids: user_ids,
      // date:date,
      // time:time,
       start_date,
      start_time,
      end_date,
      end_time,
      cohort_ids:cohort_ids
    },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
};



export const cohortAssignfinal = async (token: string, task_id: string, user_ids: number[],cohort_ids:number) => {
 
  return apiClient.post(
    '/admin/task/cohort_assign_final',
    {
      task_id: task_id,
      user_ids: user_ids,
      
      cohort_ids:cohort_ids
    },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
};





export const cohortassign = async (token: string, task_id: string[], cohort_ids: string[],  end_date: string,
  end_time: string | null,) => {
  return apiClient.post(
    '/admin/task/assign_Tasks_cohorts_v1',
    { cohort_ids,task_id , end_date,
      end_time,},
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
};


export const cohortassign2 = async (token: string, task_id: string, cohort_ids: string[],start_date: string,
  start_time: string | null,
  end_date: string,
  end_time: string | null,) => {
  return apiClient.post(
    '/admin/task/schedule_cohort_task_v1',
    { cohort_ids,task_id,start_date,
      start_time,
      end_date,
      end_time,
     },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
};


export const scheduleAssigncohort = async (token: string, task_id: string, cohort_ids: string[] | string,date:string,time:string | null) => {
 
  return apiClient.post(
    '/admin/task/schedule_cohort_task_v1',
    {
      task_id: task_id,
      cohort_ids: cohort_ids,
      date:date,
      time:time
    },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
};




 export const getcohortretaler = async (token: string, cohort_id: string) => {
 
  return apiClient.post(
    '/cohorts/get_all_cohortsusers',
    {
      cohort_id: cohort_id,
     
    },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },









      
    }
  );
};

export const getdropdowntasknames = async ({ cohort_ids }: { cohort_ids: number[] }) => {
  return await apiClient.post('cohorts/get-tasknamesdata', {
    cohort_ids, // sent in request body
  });
}


export const getdropdownoutletnames=async()=>{
   return await apiClient.get('cohorts/get_outlet_names',{
     
   })
}
export const getdropdownasmnes=async()=>{
   return await apiClient.get('cohorts/Asmanamesrejions',{
     
   })
}